export const ONBOARDING_MODAL_NAME = 'ONBOARDING_MODAL_NAME';

export const ONBOARDING_TAXES_AND_FEES_FORM_NAME = 'ONBOARDING_TAXES_AND_FEES_FORM_NAME';
export const TAXES_AND_FEES_LIST_INPUT_NAME = 'TAXES_AND_FEES_LIST_INPUT_NAME';
